/*
 * @Author: monai
 * @Date: 2021-03-12 16:52:34
 * @LastEditors: muqing
 * @LastEditTime: 2024-08-29 16:55:45
 */
//	httpClient 重构版本，优化获取 token，代码结构等
import axios from 'axios';
import { GetHeaderInfo } from "@library/activityPublic";
import { AjaxSwitch, fnAjaxOpPoll, fnAjaxCustomHeaders, getQueryString } from '@activity-business/h5-package-frameworkTool';

const ajaxSwitch = new AjaxSwitch();
const http = axios.create({
	timeout: 1000 * 8,
	// withCredentials: true,
});

//	请求拦截
http.interceptors.request.use(async config => {
	/***** 预加载请求取消 *****/
	if (getQueryString(CONFIG.prefetchProject.queryMark)) {
		const source = axios.CancelToken.source();
		config.cancelToken = source.token;
		source.cancel(`预加载内嵌 iframe 请求取消: ${config.url}`);
	}
	
	/***** 接口失败重试 *****/
	if(config?.retryConfig?.use) return config;
	
	//	未获取到 header 信息
	const defaultConfig = await new GetHeaderInfo().getHeaderInfo();
	//	设置自定义 header
	fnAjaxCustomHeaders(config, defaultConfig);
    
	//  是否需要头部增加前缀
	const isPrefix = !config.url.startsWith('http');
	if (isPrefix) {
		const apiDomain = window.ACTIVITY_H5_CONFIG?.fnGetRequestDomain(getQueryString('lang'));
		// 请求完整链接
		config.url = apiDomain + config.url;
	}

	/***** 接口失败重试默认配置合并 *****/
	const defaultRetryConfig = {
		// 是否启用失败重试功能
		use: true,
		// 当前请求重试次数
		retryNum: 0,
		/***** 以下配置为通用值 *****/
		// 最大重试次数
		RETRY_NUM_MAX: 8,
	};
	config.retryConfig = Object.assign(defaultRetryConfig,  config.retryConfig ?? {});

	/***** 开启 ajax 节流 *****/
	if(config.ajaxSwitch) {
		const msg = ajaxSwitch.mapSet(config.url, new Date().getTime());
		if(msg) return Promise.reject(msg);
	};

	return config;
}, error => {
	return error;
});

// 响应拦截
http.interceptors.response.use(response => {
	//	key 过期
	if (response.data.errorCode == 10015) document.title = 'key expired!';
	//	ajaxSwitch 删除已返回URL记录
	ajaxSwitch.mapDelete(response.config.url);
	//  运营位轮询
	fnAjaxOpPoll(response, ENV === 'build');

	return response
}, error => {
	const retryConfig = error?.config?.retryConfig ?? {};
	// ECONNABORTED => 超时
	// 'Network Error' => 源码 axios.js 处理一些异常时返回 message，此时 code 未定义。
	if(retryConfig?.use && error?.code === 'ECONNABORTED' || error?.message.includes('Network Error')) {
		retryConfig.retryNum++;
		const {retryNum, RETRY_NUM_MAX} = retryConfig;
		if(retryNum <= RETRY_NUM_MAX) {
			console.log(`[${new Date().toLocaleString()}] - 接口重试 ${error?.config.url}，当前次数: ${retryNum}` );
			return http(error.config);
		}
		else {
			// console.error(`[${new Date().toLocaleString()}] - 接口重试 ${error?.config.url} 失败！`, error);
			error?.message && (error.message = `接口重试 ${RETRY_NUM_MAX} 次失败！` + error.message);
		}
	};
	//  运营位轮询
	fnAjaxOpPoll(error.response, ENV === 'build');

	return Promise.reject(error);
})

export default http;
